/* import __COLOCATED_TEMPLATE__ from './delta-r.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class DeltaRFormula extends Component {
  @service intl;

  get rLabel() {
    return this.intl.t(`labels.${this.args.rType}`);
  }
}
